import { render, staticRenderFns } from "./event-category-landing-filter-app.vue?vue&type=template&id=e56d4e28&"
import script from "./event-category-landing-filter-app.vue?vue&type=script&lang=js&"
export * from "./event-category-landing-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports